import { yup, parsePhoneNumber } from "./imports";

export const mobileLoginSchema = (selectedCountryCode: Ref<string>) => {
  return computed(() =>
    yup.object({
      mobile: yup
        .string()
        .required("Please enter your mobile number")
        .test("is-valid-mobile", "Invalid phone number", function (value) {
          const fullNumber = `${selectedCountryCode.value}${value}`;
          return parsePhoneNumber(fullNumber)?.isValid() || false;
        }),
      mobile_password: yup.string().required("Please enter your password"),
    }),
  );
};

export const emailLoginSchema = () => {
  return computed(() =>
    yup.object({
      email: yup
        .string()
        .email("Please enter a valid email address")
        .required("Please enter your email"),
      email_password: yup.string().required("Please enter your password"),
    }),
  );
};
